import type { EagleViewProductOption } from "./types";

/**
 * Products we order for roofing workflows.
 * IDs match EagleView Measurement Orders catalog.
 * DeliveryProductId 8 = Regular Delivery.
 * MeasurementRequestTypeId 1 = Primary + Detached Garage.
 */
export const EAGLEVIEW_ORDER_PRODUCTS: EagleViewProductOption[] = [
    {
        productId: 31,
        label: "Premium — Residential",
        description: "Full residential roof measurement report",
        deliveryProductId: 8,
        measurementRequestTypeId: 1,
    },
    {
        productId: 32,
        label: "Premium — Commercial",
        description: "Full commercial roof measurement report",
        deliveryProductId: 8,
        measurementRequestTypeId: 1,
    },
    {
        productId: 13,
        label: "ClaimsReady — Residential",
        description: "Claims-oriented residential roof report",
        deliveryProductId: 8,
        measurementRequestTypeId: 1,
    },
];

export const DEFAULT_EAGLEVIEW_PRODUCT_ID =
    EAGLEVIEW_ORDER_PRODUCTS[0]?.productId ?? 31;
